export default "__VITE_ASSET__C1qS5jWA__"